import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail, Phone, ChevronRight } from "lucide-react";
import { COMPANY } from "../mock";

export const LegalPage = ({ icon: Icon, badge, title, updated, intro, sections, breadcrumb }) => (
  <div>
    {/* Hero */}
    <section className="relative pt-24 pb-10 md:pt-40 md:pb-20 bg-brand-navy text-white overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-navy via-brand-ocean/30 to-brand-navy" />
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-brand-sky/20 blur-3xl" />
      <div className="container-x relative">
        <nav className="flex items-center gap-2 text-sm text-white/60 mb-5" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white">Home</Link>
          <ChevronRight className="h-4 w-4" />
          <span className="text-brand-gold2">{breadcrumb}</span>
        </nav>
        <div className="flex items-center gap-3 mb-4">
          <span className="grid place-items-center h-12 w-12 rounded-xl bg-brand-gold text-brand-navy">
            <Icon className="h-7 w-7" />
          </span>
          {badge && (
            <span className="inline-flex items-center gap-1.5 text-xs font-heading font-bold uppercase tracking-wider bg-white/10 rounded-full px-3 py-1 ring-1 ring-white/20">
              <ShieldCheck className="h-3.5 w-3.5 text-brand-sky2" /> {badge}
            </span>
          )}
        </div>
        <h1 className="text-3xl md:text-5xl font-heading font-extrabold">{title}</h1>
        <p className="text-white/70 mt-3">Last Updated: {updated}</p>
      </div>
    </section>

    {/* Body */}
    <section className="section-y bg-white">
      <div className="container-x max-w-4xl">
        {intro && <p className="text-brand-slate leading-relaxed text-lg mb-10">{intro}</p>}
        <div className="space-y-10">
          {sections.map((sec, i) => (
            <article key={i} className="reveal">
              <h2 className="text-xl md:text-2xl font-heading font-extrabold text-brand-navy relative pl-4 mb-4">
                <span className="absolute left-0 top-1 bottom-1 w-1.5 rounded-full bg-brand-gold" />
                {sec.heading}
              </h2>
              <div className="space-y-3 text-brand-slate leading-relaxed">
                {sec.body?.map((p, j) => <p key={j}>{p}</p>)}
                {sec.list && (
                  <ul className="space-y-2 mt-2">
                    {sec.list.map((li, k) => (
                      <li key={k} className="flex items-start gap-2.5">
                        <span className="mt-2 h-1.5 w-1.5 rounded-full bg-brand-sky shrink-0" />
                        <span>{li}</span>
                      </li>
                    ))}
                  </ul>
                )}
                {sec.after?.map((p, j) => <p key={`a${j}`}>{p}</p>)}
              </div>
            </article>
          ))}
        </div>

        {/* Contact card */}
        <div className="mt-14 rounded-2xl bg-brand-mist p-7 md:p-9 reveal">
          <h3 className="text-xl font-heading font-extrabold text-brand-navy mb-2">Questions?</h3>
          <p className="text-brand-slate mb-5">
            Contact our team for any questions regarding this policy, your personal data, or SMS communications.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a href={COMPANY.phoneHref} data-call-source="legal-page" className="inline-flex items-center gap-2 h-12 px-6 rounded-lg bg-brand-ocean hover:bg-brand-sky text-white font-heading font-bold transition-colors">
              <Phone className="h-4 w-4" /> {COMPANY.phone}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="inline-flex items-center gap-2 h-12 px-6 rounded-lg bg-white ring-1 ring-brand-slate/20 hover:ring-brand-ocean text-brand-navy font-heading font-bold transition-all">
              <Mail className="h-4 w-4" /> {COMPANY.email}
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
);
